import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import locale from 'date-fns/locale/en-US';
import { putRepatriationsTransactionsEditRequestActionCreator } from '../redux/actions/RepatriationsTransactionsEditActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';
import { getInboundImpcsOfSingleOperator, getLeftPostalOperatorsCodesOnly } from '../../../../../../common/user/redux/selectors/UserDataSelectors';
import { getImpcsOfSingleInboundOperatorRequestActionCreator } from '../../../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

const operators = process.env.relatedOperators;
const relatedOperators = operators.split('|');

class RepatriationsTransactionsEditDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.row.row.comments,
      departureDateTime: props.row.row.departureDateTime !== undefined
        ? moment(props.row.row.departureDateTime).format(DATE_FORMATS.inputDateTime) : moment(props.row.row.departureDate).format(DATE_FORMATS.inputDateTime),
      impcFrom: props.row.row.impcFrom !== undefined ? props.row.row.impcFrom : props.row.row.outboundImpc,
      inboundImpc: props.row.row.impcTo !== undefined ? props.row.row.impcTo : props.row.row.inboundImpc,
      operatorFrom: props.row.row.operatorFrom !== undefined ? props.row.row.operatorFrom : props.row.row.outboundOperator,
      inboundOperator: props.row.row.operatorTo !== undefined ? props.row.row.operatorTo : props.row.row.inboundOperator,
      plannedArrivalDateTime: props.row.row.arrivalDateTime !== undefined
        ? moment(props.row.row.arrivalDateTime).format(DATE_FORMATS.inputDateTime) : moment(props.row.row.arrivalDate).format(DATE_FORMATS.inputDateTime),
      quantity: props.row.row.quantity !== undefined ? props.row.row.quantity : props.row.row.quantityPreAdvised,
      transactionId: props.row.row.id,
      errorQuantity: '',
    };
    this.handleNewInboundOperator = this.handleNewInboundOperator.bind(this);
    this.handleNewInboundIMPC = this.handleNewInboundIMPC.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleDepartureDate = this.handleDepartureDate.bind(this);
    this.handleArrivalDate = this.handleArrivalDate.bind(this);
    this.confirmEdit = this.confirmEdit.bind(this);
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, props.row.row.operatorTo);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.inboundOperator !== prevState.inboundOperator) {
      this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.inboundOperator);
    }
  }

  isFormValid = () => !(this.state.quantity === ''
    || this.state.quantity === undefined
    || (moment(this.state.departureDateTime).isAfter(this.state.plannedArrivalDateTime))
    || this.state.departureDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === 'Invalid date'
    || this.state.inboundImpc === 'Select IMPC'
    || this.state.inboundOperator === undefined
    || this.state.errorQuantity === 'Quantity value can not be negative'
    || this.state.inboundImpc === 'Select...')

  handleNewInboundOperator(selectedOption) {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      inboundOperator: selectedOption.value,
      inboundImpc: 'Select IMPC',
    });
  }

  handleNewInboundIMPC(selectedOption) {
    this.setState({
      inboundImpc: selectedOption.value,
    });
  }

  handleQuantity(e) {
    let error = '';
    if (parseInt(e.target.value, 0) < 0) {
      error = 'Quantity value can not be negative';
    }
    this.setState({
      quantity: e.target.value,
      errorQuantity: error,
    });
  }

  handleComments(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleDepartureDate(date) {
    this.setState({
      departureDateTime: moment(date).format(DATE_FORMATS.inputDateTime),
    });
  }

  handleArrivalDate(date) {
    this.setState({
      plannedArrivalDateTime: moment(date).format(DATE_FORMATS.inputDateTime),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmEdit() {
    await this.props.putRepatriationsTransactionsEditRequestActionCreator(
      this.props.appContext,
      this.state.departureDateTime,
      this.state.description,
      this.state.inboundImpc,
      this.state.inboundOperator,
      this.state.plannedArrivalDateTime,
      this.state.quantity,
      this.state.transactionId,
    );
    this.props.closeDialog();
    await this.props.refreshHistories();
    this.props.refreshTransactions();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Edit Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Outbound Operator
                </td>
                <td className="selected-impc">
                  <Input value={this.state.operatorFrom} disabled />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Outbound IMPC
                </td>
                <td className="selected-impc">
                  <Input value={this.state.impcFrom} disabled />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound Operator
                </td>
                {this.state.inboundOperator !== this.state.operatorFrom && (
                <td className="selected-impc">
                  <Select
                    value={this.state.inboundOperator}
                    placeholder={this.state.inboundOperator}
                    options={relatedOperators.includes(this.state.operatorFrom)
                      ? this.props.operatorToOptions.filter((item) => !relatedOperators.includes(item.value) && (item.value !== this.state.operatorFrom))
                      : this.props.operatorToOptions.filter((item) => item.value !== this.state.operatorFrom)}
                    onChange={this.handleNewInboundOperator}
                  />
                </td>
                )}
                {this.state.inboundOperator === this.state.operatorFrom && (
                  <td className="selected-impc">
                    <Input value={this.state.inboundOperator} disabled />
                  </td>
                )}
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound IMPC
                </td>
                {this.state.inboundOperator === this.state.operatorFrom && (
                  <td className="selected-impc">
                    <Select
                      value={this.state.inboundImpc}
                      placeholder={this.state.inboundImpc}
                      options={this.mapImpcListToSelectOptions(this.props.impcToList.filter((item) => item !== this.state.impcFrom))}
                      onChange={this.handleNewInboundIMPC}
                    />
                  </td>
                )}
                {this.state.inboundOperator !== this.state.operatorFrom && (
                  <td className="selected-impc">
                    <Select
                      value={this.state.inboundImpc}
                      placeholder={this.state.inboundImpc}
                      options={this.mapImpcListToSelectOptions(this.props.impcToList)}
                      onChange={this.handleNewInboundIMPC}
                    />
                  </td>
                )}
              </tr>
              <tr>
                <td className="selected-impc">
                  Description
                </td>
                <td className="selected-impc">
                  <Input
                    value={this.state.description}
                    onChange={this.handleComments}
                    maxLength="40"
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Quantity
                </td>
                <td className="selected-impc">
                  <Input
                    id="quantity"
                    type="number"
                    value={this.state.quantity}
                    onChange={this.handleQuantity}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorQuantity}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Departure date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.departureDateTime}
                        maxDate={this.state.plannedArrivalDateTime}
                        maxDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        onChange={this.handleDepartureDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Arrival date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.plannedArrivalDateTime}
                        minDate={this.state.departureDateTime}
                        minDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        onChange={this.handleArrivalDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmEdit}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

RepatriationsTransactionsEditDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  impcToList: PropTypes.arrayOf(PropTypes.string),
  operatorToOptions: PropTypes.arrayOf(PropTypes.object),
  putRepatriationsTransactionsEditRequestActionCreator: PropTypes.func,
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    impcToList: getInboundImpcsOfSingleOperator(state),
    operatorToOptions: getLeftPostalOperatorsCodesOnly(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  putRepatriationsTransactionsEditRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RepatriationsTransactionsEditDialog);
